import revertIcon from "../../../../assets/images/revert.svg";
import redo from "../../../../assets/images/redo.svg";
import trim_svg from "../../../../assets/images/image-trim.svg";

export const ButtonsToolBar = ({
    trim_programs_space,
    locationState,
    loaderStatus,
    updateSchedule,
    undoGridList,
    redoGridList,
    canUndo,
    canRedo
}) => {
    return (
        <div className="right-side d-flex">
            <a className='btn btn-revert mx-1 p-1' style={{ width: '2rem', height: '2rem', background: "#444649" }}><img src={revertIcon} onClick={undoGridList} disabled={!canUndo} width={24} /></a>
            <a className='btn btn-revert mx-1 p-1' style={{ width: '2rem', height: '2rem', background: "#444649" }}><img src={redo} width={35} onClick={redoGridList} disabled={!canRedo}/></a>
            <a className='btn btn-revert mx-1 p-1' style={{ width: '2rem', height: '2rem', background: "#444649" }} onClick={() => trim_programs_space()}><img src={trim_svg} width={24} /></a>
            {
                locationState?.state?.permission === "edit" &&
                <>
                    <div className="btn-group mx-1">
                        <button
                            type="button"
                            className="btn btn-primary p-2 radius-8x"
                            onClick={() => updateSchedule()}
                            disabled={loaderStatus}
                            style={{ height: "2rem", fontSize: "0.875rem", fontWeight: "400" }}
                        >
                            {
                                loaderStatus &&
                                <div className="loader me-1" style={{ width: "20px", height: "20px", marginBottom: "0px" }}>
                                </div>
                            }
                            Update
                        </button>
                    </div>
                </>
            }
            <button className='btn btn-danger mx-1 radius-8x' style={{ height: "2rem", fontSize: "0.875rem" }}>Auto Schedule</button>
        </div>
    )
}